import { useState, useMemo, useEffect } from "react";
import { authService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { RequestStatus } from "..";

export type UseRepeatSendInviteEmail = (email: string) => Promise<void>;
export type UseRepeatSendConfirmationEmail = (email: string) => Promise<void>;
export type UseRepeatSendPassWordExpiredEmail = (email: string) => Promise<void>;

export function useRepeatSendEmail(): [RequestStatus, UseRepeatSendConfirmationEmail, UseRepeatSendInviteEmail, UseRepeatSendPassWordExpiredEmail] {
  const [status, setStatus] = useState(RequestStatus.None);
  const repeatSendConfirmationEmail: UseRepeatSendConfirmationEmail = useMemo(
    () => async (email) => {
      try {
        await authService.repeatSendConfirmationEmail(email);
      } catch (err) {}
    },
    [],
  );
  const repeatSendInviteEmail: UseRepeatSendInviteEmail = useMemo(
    () => async (email) => {
      try {
        await authService.repeatSendInviteEmail(email);
      } catch (err) {}
    },
    [],
  );
  const repeatSendPassWordExpiredEmail: UseRepeatSendPassWordExpiredEmail = useMemo(
    () => async (email) => {
      try {
        await authService.repeatSendPassWordExpiredEmail(email);
      } catch (err) {}
    },
    [],
  );
  useEffect(() => {
    const sub = authService.status$.subscribe((code) => {
      setStatus(code);
    });
    return unsubscribe(sub);
  }, []);

  return [status, repeatSendConfirmationEmail, repeatSendInviteEmail, repeatSendPassWordExpiredEmail];
}
